import React from "react";
import { CustomCard } from "../../CustomCard";
import { Skeleton } from "@material-ui/lab";
import { Box, Divider } from "@material-ui/core";

// styles
import useStyles from "./styles";

const ProprtyInfoComponentSkeleton = ({}) => {
  const styles = useStyles();
  return (
    <CustomCard
      boxShadow="xs"
      borderRadius="xl"
      borderColor="secondary"
      classes={styles.wrapperProprtyInfoCard}
    >
      <Box className={styles.containerLeftImage}>
        <Skeleton
          variant="rect"
          width={"100%"}
          height={"100%"}
          style={{ borderRadius: "12px" }}
        />
      </Box>
      <Box className={styles.containerInfoProp}>
        <Box className={styles.propertyInfoDetails}>
          <Skeleton variant="text" width={100} height={30} />
          <Divider className={styles.dividerPropInfo} />
          <Box className={styles.containerPropInfoDetails}>
            <Box className={styles.containerLeftDetails}>
              <Box className={styles.containerInfoItem}>
                <Skeleton variant="text" width={100} height={30} />
                <Skeleton variant="text" width={100} height={30} />
              </Box>
              <Box className={styles.containerInfoItem}>
                <Skeleton variant="text" width={100} height={30} />
                <Box className={styles.containerLocationValue}>
                  <Skeleton variant="text" width={20} height={30} />

                  <Skeleton variant="text" width={100} height={30} />
                </Box>
              </Box>
              <Box className={styles.containerInfoItem}>
                <Skeleton variant="text" width={100} height={30} />

                <Skeleton variant="text" width={100} height={30} />
              </Box>
              <Box className={styles.containerInfoItem}>
                <Skeleton variant="text" width={100} height={30} />
                <Skeleton variant="text" width={100} height={30} />
              </Box>
            </Box>
            <Box className={styles.containerRightDetails}>
              <Skeleton
                variant="rect"
                width={50}
                height={50}
                style={{ borderRadius: "12px" }}
              />
              <Box className={styles.containerContactInfo}>
                <Skeleton variant="text" width={100} height={30} />
                <Skeleton variant="text" width={100} height={30} />
                <Skeleton variant="text" width={100} height={30} />
              </Box>
            </Box>
          </Box>
        </Box>
        <Box>
          <Skeleton variant="text" width={100} height={30} />

          <Divider className={styles.divider} />
        </Box>
        <Box className={styles.containerAreaInformation}>
          <Box className={styles.areaInfoItem}>
            <Skeleton variant="text" width={40} height={50} />
            <Skeleton variant="text" width={100} height={24} />
            <Skeleton variant="text" width={100} height={24} />
          </Box>
          <Box className={styles.areaInfoItem}>
            <Skeleton variant="text" width={40} height={50} />
            <Skeleton variant="text" width={100} height={24} />
            <Skeleton variant="text" width={100} height={24} />
          </Box>
          <Box>
            <Skeleton variant="text" width={40} height={50} />
            <Skeleton variant="text" width={100} height={24} />
            <Skeleton variant="text" width={100} height={24} />
          </Box>
          <Box>
            <Skeleton variant="text" width={40} height={50} />
            <Skeleton variant="text" width={100} height={24} />
            <Skeleton variant="text" width={100} height={24} />
          </Box>
        </Box>
        <Skeleton variant="text" width={40} height={50} />

        <Box>
          <Skeleton variant="text" width={100} height={24} />

          <Divider className={styles.divider} />
          <Box className={styles.containerImages}>
            {[...Array(4)].map((_, index) => (
              <Box className={styles.containerImageItem}>
                <Skeleton
                  variant="rect"
                  width={"100%"}
                  height={"100%"}
                  style={{ borderRadius: "12px" }}
                />
              </Box>
            ))}
          </Box>
        </Box>
      </Box>
    </CustomCard>
  );
};

export default ProprtyInfoComponentSkeleton;
